/* eslint-disable react/sort-comp */
import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, Redirect } from '@bingads-webui-campaign-react/router';
import { withInstrumentation } from '@bingads-webui-react/hoc-with-instrumentation';
import { withCurrentExpandedScope } from '@bingads-webui-campaign-react/use-current-scope-entity';
import { LISTING_GROUP_TREE_ROUTING, LISTING_GROUP_LIST_ROUTING } from './constant';
import { StyledListingGroupsPage } from './listing-groups-page';

class ListingGroupsRouterShell extends React.Component {
  static propTypes = {
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
      search: PropTypes.string.isRequired,
    }).isRequired,
    scope: PropTypes.shape({
      save: PropTypes.func,
      values: PropTypes.shape({
        assetGroupId: PropTypes.number,
        campaignId: PropTypes.number,
      }).isRequired,
    }).isRequired,
    currentCampaign: PropTypes.shape({
      Id: PropTypes.string,
    }).isRequired,
    currentAdGroup: PropTypes.shape({
      Id: PropTypes.string,
    }).isRequired,
    instrumentation: PropTypes.shape({}).isRequired,
    changeLayout: PropTypes.func.isRequired,
  };

  static defaultProps = {
  };

  constructor(props) {
    super(props);
    this.props.changeLayout({ tab: { disableCompare: true } });
  }

  componentWillUnmount() {
    this.props.changeLayout({ tab: { disableCompare: false } });
  }

  render() {
    return (
      <Switch>
        <Route
          exact
          path={LISTING_GROUP_TREE_ROUTING}
          render={
            () => (
              // Will change back to list view when in hierarchy view of campaign scope
              this.props.scope.values.assetGroupId
              ? <React.Fragment><StyledListingGroupsPage {...this.props} gridType="Tree" key="Tree" /></React.Fragment>
              : <Redirect to={`${LISTING_GROUP_LIST_ROUTING}?&campaignId=${this.props.scope.values.campaignId}`} />
            )
          }
        />
        <Route
          exact
          path={LISTING_GROUP_LIST_ROUTING}
          render={
            () => (
              <React.Fragment>
                <StyledListingGroupsPage {...this.props} gridType="List" key="List" />
              </React.Fragment>
            )
          }
        />
      </Switch>
    );
  }
}

export const ListingGroupsShell = withInstrumentation(withCurrentExpandedScope(ListingGroupsRouterShell));
